import React from "react";
import { MapPin } from "lucide-react";
import { MAP_IMAGE } from "../lib/execora";

export const ServiceArea = () => {
  return (
    <section
      id="service-area"
      data-testid="service-area-section"
      className="relative py-16 md:py-24 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-[2rem] border border-slate-200">
          <img
            src={MAP_IMAGE}
            alt="Detailed street map of Indiranagar, Bengaluru"
            className="absolute inset-0 h-full w-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-slate-900/80 via-slate-900/60 to-slate-900/30" aria-hidden="true" />

          <div className="relative px-6 sm:px-10 lg:px-14 py-16 sm:py-20 lg:py-28 text-white">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 backdrop-blur border border-white/20 text-xs font-medium tracking-wide">
              <MapPin className="h-3.5 w-3.5 text-[#84cc15]" strokeWidth={2.2} />
              Service area
            </div>
            <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.1] max-w-2xl">
              Currently serving <br />
              <span className="text-[#84cc15]">Indiranagar, Bengaluru</span>
            </h2>
            <p className="mt-5 max-w-xl text-slate-200 text-base sm:text-lg leading-relaxed">
              100 Feet Road, Defence Colony, HAL 2nd & 3rd Stage, and around CMH Road to Binnamangala — if you're nearby, we've got you covered.
            </p>

            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-3 max-w-xl">
              {[
               
  { k: "1 km", v: "Typical service radius" },
  // { k: "Up to 90 min", v: "Typical delivery time" },
  { k: "₹5,000", v: "Max item value" },
  { k: "6 days", v: "Mon - Sat,  9 AM - 7 PM" },

              ].map((s) => (
                <div
                  key={s.k}
                  className="rounded-xl bg-white/8 backdrop-blur-sm border border-white/15 p-3"
                >
                  <div className="text-lg sm:text-xl font-semibold text-white">{s.k}</div>
                  <div className="text-[11px] sm:text-xs text-slate-300 mt-0.5 leading-snug">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;
